<template>
  <div class="table offer-info">
    <el-form ref="form" :model="c_data">
      <el-table :data="c_data" ref="dataTable" border style="margin-top: 10px ;" :header-cell-class-name="headerCellClassName">
        <el-table-column v-if="canEdit" align="center" type="selection" width="55">
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="facilityName" label="Supplier/Facility" width="250px">
          <template slot-scope="scope">
            <div v-if="scope.row.isNew=='N' || !c_canEdit">
              <el-form-item>
                <el-input v-model="scope.row.plantName" :title="scope.row.plantName" disabled></el-input>
              </el-form-item>
            </div>
            <div v-else="scope.row.isNew=='Y'">
              <el-form-item :prop="`[${scope.$index}].plantId`" :rules="requiredRule">
                <el-select :disabled="!c_canEdit" v-model="scope.row.plantId" style="width: 100%">
                  <el-option :key="index" v-for="(item,index) in plantList" :label="item.supplierName" :value="item.tmSupplierId"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="supplierDc" label="Supplied DC" width="200px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].supplierDc`" :rules="requiredRule">
              <el-select v-model="scope.row.supplierDc" :disabled="!c_canEdit || scope.row.transportationMethod == 'SUPPLIER'" multiple @change="changeCurrentFreight(scope.row)">
                <el-option v-for="(item,index) in dcList" :label="item.dcName" :value="item.tmDcId"></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="tradeTerm" label="Trade Term" :width="200">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].tradeTerm`" :rules="(scope.row.isNew=='Y')?requiredRule:[]">
              <ic-select v-model="scope.row.tradeTerm" table="TM_MATERIAL_RECORD" field="PRICE_TYPE" :disabled="!c_canEdit || scope.row.isNew=='N'"></ic-select>
              <el-input :title="scope.row.tradeTermOther" maxlength="30" v-model="scope.row.tradeTermOther" v-if="scope.row.tradeTerm == '5'"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" v-if="isSupplier" prop="newBoolean" width="100" :label="$t('fpaManage.permanent.isNew')">
          <template slot-scope="scope">
            <el-form-item>
              <el-switch active-value="Y" :disabled="!c_canEdit" inactive-value="N" v-model="scope.row.isNew"></el-switch>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="localItem" label="Local Item#" width="150px" column-key="localItem">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].localItem`" :rules="(scope.row.isNew=='Y')?[]:requiredRule">
              <MaterialInput v-model="scope.row.localItem" @pick="pickMaterial($event,scope.row)" :can-pick="scope.row.isNew=='N'" :disabled="!c_canEdit || scope.row.isNew=='Y'"></MaterialInput>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="productDescription" label="Product Description" width="200px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].productDescription`" :rules="(scope.row.isNew=='Y')?requiredRule:[]">
              <el-input v-model="scope.row.productDescription" :title="scope.row.productDescription" :disabled="!c_canEdit || scope.row.isNew=='N'"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="packingSizePerUom" label="Packing Size per SU" width="200px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].packingSizePerUom`" :rules="(scope.row.isNew=='Y')?requiredRule:[]">
              <el-input v-model="scope.row.packingSizePerUom" :title="scope.row.packingSizePerUom" :disabled="!c_canEdit || scope.row.isNew=='N'"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="uom" label="Settlement Unit (per SU)" width="120">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].uom`" :rules="(scope.row.isNew=='Y')?requiredRule:[]">
              <ic-select table="TM_MATERIAL_RECORD" :disabled="!c_canEdit || scope.row.isNew=='N'" field="MINIMUM_ORDER_UNIT" v-model="scope.row.uom"></ic-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="currentPricePerUom" label="Current Price per UoM (excluding VAT)" width="170px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].currentPricePerUom`">
              <el-input v-model="scope.row.currentPricePerUom" :title="scope.row.currentPricePerUom" :disabled="true"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="newPricePerUom" label="New Price per UoM (excluding VAT)" width="150px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].newPricePerUom`" :rules="[requireRule,priceRule]">
              <el-input @input="sumDDPCost(scope.row)" @change="changeNunToSixBit(scope.row,'newPricePerUom')" v-model="scope.row.newPricePerUom" :disabled="!c_canEdit" :title="scope.row.newPricePerUom"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="currency" label="Currency" width="100px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].currency`" :rules="(scope.row.isNew=='Y')?requiredRule:[]">
              <ic-select :filterable="true" table="BASE" field="CURRENCY_CODE" :disabled="true" v-model="scope.row.currency"></ic-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="vat" label="VAT" width="80px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].currency`" :rules="(scope.row.isNew=='Y')?requiredRule:[]">
              <ic-select table="TM_MATERIAL_RECORD" field="URCHASE_TAX_RATE" :disabled="!c_canEdit" v-model="scope.row.vat"></ic-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="change" label="Change" width="100px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].change`">
              <el-input disabled :value="changePercent(scope.row.newPricePerUom,scope.row.currentPricePerUom)" style="width:80%;"></el-input>%
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="transportationMethod" label="Delivery Type" width="150px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].transportationMethod`" :rules="(scope.row.isNew=='N')?[]:requiredRule">
              <ic-select @change="changeCurrentFreight(scope.row)" table="TM_MATERIAL" field="DIS_TYPE" v-model="scope.row.transportationMethod" :disabled="!c_canEdit" :excludes="['thirdParty']"></ic-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="freight" label="Freight" width="150px">
          <template slot-scope="scope">
            <el-form-item v-if="scope.row.transportationMethod != 'DC'" :prop="`[${scope.$index}].freight`" :rules="[requireRule,priceRule]">
              <el-input @input="sumDDPCost(scope.row)" @change="changeNunToSixBit(scope.row,'freight')" :disabled="!c_canEdit" v-model="scope.row.freight"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="currentFreight" label="Current Freight" width="150px">
          <template slot-scope="scope">{{scope.row.currentFreight}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="ddpCost" label="Total Cost(excluding VAT)" width="150px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].ddpCost`" :rules="[requireRule,priceRule]">
              <el-input v-model="scope.row.ddpCost" @change="changeNunToSixBit(scope.row,'ddpCost')" :disabled="!c_canEdit"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="validFrom" label="Valid From(Date)" width="150px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].validFrom`" :rules="requiredRule">
              <el-date-picker :picker-options="{disabledDate:maxData(scope.row.validTo)}" type="date" placeholder="选择日期" v-model="scope.row.validFrom" :disabled="!c_canEdit" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="validTo" label="Valid To(Date)" width="150px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].validTo`" :rules="requiredRule">
              <el-date-picker :picker-options="{disabledDate:minDate(scope.row.validFrom)}" type="date" placeholder="选择日期" v-model="scope.row.validTo" :disabled="!c_canEdit" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="volumeEstimation" label="Volume Estimation" width="150px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].volumeEstimation`">
              <el-input v-model="scope.row.volumeEstimation" @change="changeNunToSixBit(scope.row,'volumeEstimation')" :disabled="!c_canEdit"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="contentPerUom" label="Content Per SU" width="150px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].contentPerUom`">
              <el-input @input="sumDDPCost(scope.row)" @change="changeNunToSixBit(scope.row,'contentPerUom')" v-model="scope.row.contentPerUom" :disabled="!c_canEdit"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="unit" label="Unit" width="150px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].unit`">
              <ic-select table="TT_FPA_PQCN" field="UNIT" :disabled="!c_canEdit" v-model="scope.row.unit"></ic-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="pricePerUnit" label="Price per Unit" width="150px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].pricePerUnit`">
              <el-input v-model="scope.row.pricePerUnit" :title="scope.row.pricePerUnit" disabled></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="remark" label="Remark" width="200px">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].remark`">
              <el-input v-model="scope.row.remark" :disabled="!c_canEdit" :title="scope.row.remark"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>
<script>
import router from '../../../router';
import { apiService } from "@/api/ssr-manage/ssr-manage";
import { Message } from "element-ui";
import commonMethods from "@/utils/commonMethods";
import utils from "@/utils/commonFun";
import fpaPermanentApi from "@/api/fpa/fpaPermanent";
import commonFun from "@/utils/commonFun";
import supplier from "@/api/supplier/supplier";
import DC from "@/api/DC/DC";
import IcSelect from "@/components/common/icSelect";
import { materialService } from "@/api/base-data/material";
import MaterialInput from "@/components/page/base-data/materialInput";
import moment from "moment"
import { materialPriceDataApi } from "@/api/base-data/materialPriceData";

export default {
  name: 'pqcp-table',
  extends: commonMethods,
  components: { MaterialInput, IcSelect },
  props: {
    data: Array,
    canEdit: Boolean,
    canEditFreightForcast: {
      type: Boolean,
      default: false
    }
  },
  computed: {

    changePercent() {
      return (newVal, oldVal) => {
        let priceRange = this.changePrice(newVal, oldVal)
        if (commonFun.isEmpty(priceRange) || isNaN(priceRange)) {
          return "";
        } else {
          return ((priceRange / oldVal) * 100).toFixed(2);
        }
      }
    },
  },
  data() {
    return {
      c_canEdit: false,
      c_data: [],
      plantList: [],
      dcList: [],
      requiredRule: [{ required: true, message: 'Can not be empty!', trigger: 'blur' }],
      requireRule: { required: true, message: 'Can not be empty!', trigger: 'blur' },
      priceRule: {
        required: true, validator: (rule, value, callback) => {
          if (isNaN(value) || value < 0) {
            callback('Number error!');
          }
          if (commonFun.isNotEmpty(value)) {
            let arr = (value + "").split(".");
            if (arr.length == 2 && arr[1].length > 6) {
              callback('Please enter up to 6 decimal places');
            }
          }
          callback();
        }, trigger: 'blur'
      },
      numberRule: {
        required: true, validator: (rule, value, callback) => {
          if (isNaN(value) || value < 0) {
            callback('Number error!');
          }
          callback();
        }, trigger: 'blur'
      },
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    changeNunToSixBit(row, key) {
      if (commonFun.isNotEmpty(row[key]) && !isNaN(row[key])) {
        this.$set(row, key, (row[key] - 0).toFixed(6));
      }
    },
    changeCurrentFreight(row) {
      let that = this;
      if (commonFun.isEmpty(row.supplierDc) || commonFun.isEmpty(row.localItem)) {
        return null;
      } else {
        let data = {
          dcIdList: row.supplierDc,
          eightBitCode: row.localItem,
        };

        if (row.transportationMethod == "SUPPLIER") {
          that.$set(row, "supplierDc", [-1]);
        } else if (row.transportationMethod != "SUPPLIER" && row.supplierDc != null && row.supplierDc.length == 1 && row.supplierDc[0] == -1) {
          that.$set(row, "supplierDc", []);
        }

        if (commonFun.isEmpty(row.localItem)) {
          return;
        }
        if (row.transportationMethod == "SUPPLIER") {
          fpaPermanentApi.getCurrentDirectFreight(row.localItem).then(res => {
            if (res.code == 200) {
              that.$set(row, "currentFreight", res.data);
            }
          })
        } else {
          materialPriceDataApi.listProductFreightByMaterialCode(data).then(res => {
            if (res.code == 200) {
              if (commonFun.isNotEmpty(res.data)) {
                that.$set(row, "currentFreight", res.data[0].productPrice);
              }
            }
          });
        }
      }
    },
    headerCellClassName(cell, index) {
      if (cell.column.label == "Content Per SU" || cell.column.label == "Unit" || cell.column.label == "Price per Unit") {
        return 'thBackgroundColor';
      } else {
        return null;
      }
    },
    maxData(maxDate) {
      return (val) => {
        if (maxDate != null) {
          return moment(val).diff(moment(maxDate)) > 0;
        } else {
          return false;
        }
      }
    },
    minDate(minDate) {
      return (val) => {
        if (minDate != null) {
          return moment(val).diff(moment(minDate)) < 0;
        } else {
          return false;
        }
      }
    },
    init() {
      this.c_canEdit = this.canEdit;
      this.c_data = this.data;
      let that = this;
      if (this.canEdit) {
        supplier.getMyPlantList().then(res => {
          that.plantList = res.data;
        });
      }
      DC.listAllDc({}).then(res => {
        that.dcList = res.data;
      });
    },
    delSelect() {
      let selectRows = this.$refs.dataTable.selection;
      if (selectRows.length == 0) {
        Message.warning('Please select data!');
      }
      selectRows.forEach(row => {
        this.c_data.splice(this.c_data.findIndex(tmp => tmp == row), 1);
      });
    },
    pickMaterial(material, row) {
      if (row.isNew == 'N' && !utils.isEmpty(material.eightBitCode)) {
        fpaPermanentApi.fpaMaterialSearch(material.eightBitCode).then((res) => {
          if (res.code == 200) {
            if (res.data == null) {
              //请输入可用物料!
              this.$message.error(this.$t('fpaManage.permanent.localItemExistCheck'));
              return false;
            }
            this.$set(row, 'plantId', res.data.plantId);
            this.$set(row, 'supplierDc', res.data.suppliedDcArr.map(res => res - 0));
            this.$set(row, 'plantName', res.data.facilityName);
            this.$set(row, 'tradeTerm', res.data.tradeTerm);
            this.$set(row, 'productDescription', res.data.productDescription);

            let packingSizePerUom = '';
            if (res.data.outerPackageContainsNum) {
              packingSizePerUom += res.data.outerPackageContainsNum;
            }
            packingSizePerUom += '*';
            if (res.data.quantityUomInnerNum) {
              packingSizePerUom += res.data.quantityUomInnerNum;
            }
            if (res.data.uomValue) {
              packingSizePerUom += ' ' + res.data.uomValue;
            }
            this.$set(row, 'packingSizePerUom', packingSizePerUom);
            this.$set(row, 'uom', res.data.uom);
            this.$set(row, 'currentPricePerUom', res.data.currentPricePerUom);
            this.$set(row, 'vat', res.data.vat);
            this.$set(row, 'transportationMethod', res.data.transportaionMethod);
            this.$set(row, 'freight', res.data.freight);
            this.$set(row, 'validFrom', res.data.validFrom);
            this.$set(row, 'validTo', res.data.validTo);
            this.$set(row, 'remark', res.data.remark);

            this.changeCurrentFreight(row);
          } else {
            Message.error(res.msg || 'Operate Error');
          }
        });
      }
    },
    changePrice(newVal, oldVal) {
      if (commonFun.isEmpty(newVal) || commonFun.isEmpty(oldVal) || isNaN(newVal) || isNaN(oldVal)) {
        return "";
      }
      let change = newVal - oldVal;
      if (isNaN(change)) {
        return "";
      } else {
        return change;
      }
    },
    sumDDPCost(row) {
      row.pricePerUnit = "";
      if (commonFun.isNotEmpty(row.newPricePerUom)) {
        // if (commonFun.isNotEmpty(row.freight)) {
        //     let total = row.newPricePerUom - (-row.freight);
        //     row.ddpCost = isNaN(total)?"":total;
        // }
        if (commonFun.isNotEmpty(row.contentPerUom)) {
          let price = row.newPricePerUom / row.contentPerUom;
          row.pricePerUnit = isNaN(price) ? "" : price.toFixed(6);
        }
      }

    }
  },
  watch: {
    data() {
      this.init();
    },
    canEdit(val) {
      this.c_canEdit = this.canEdit;
    },
    c_data(val) {
      this.$emit("update:data", this.c_data);
    }
  }
}
</script>
<style>
/*.el-form-item--mini.el-form-item:not(.is-error), .el-form-item--small.el-form-item:not(.is-error){*/
/*    margin-bottom: 0;*/
/*}*/
.el-table thead th.thBackgroundColor {
  background: #67c23a !important;
}
</style>
